import React from "react";
import EditIcon from "../../../assets/icons/edit";
import InfoIcon from "../../../assets/icons/info";
import CircleIcon from "../../../assets/icons/circle";
import SavedIcon from "../../../assets/icons/saved";
import OpenedParentIcon from "../../../assets/icons/openParent";
import ClosedParentIcon from "../../../assets/icons/closeParent";
import useObjectInput from "../../../hooks/useObjectInput";

// Component to render the appropriate parent icon based on whether children are shown or not
const ParentIcon = ({ showChildren, toggleShowHide }) => (
  <div onClick={toggleShowHide}>
    {showChildren ? <OpenedParentIcon /> : <ClosedParentIcon />}
  </div>
);

// Component to render the header wrapper with appropriate background color based on highlightData
const HeaderWrapper = ({ showHeader, highlightData, item, toggleShowHide }) => {
  const style = highlightData.dependenciesId.some((id) => id === item?.id)
    ? { background: "#fac711" }
    : highlightData.objectId === item?.id
    ? { background: "red" }
    : {};

  return (
    <div
      className={`h3-wrapper ${showHeader ? "show-header" : ""}`}
      style={style}
    >
      <h3 className="cp" onClick={toggleShowHide} id={item.id}>
        {item.name}
      </h3>
    </div>
  );
};

// in tree view we are supposed to show the node header with the GOINode
const NodeHeader = ({
  style,
  item,
  toggleShowHide,
  showChildren,
  editMode,
  showHeader,
  toggleShowHeader,
}) => {
  const { highlightData, setActiveObjectId, id } = useObjectInput();

  return (
    <div style={style} className="flex-h">
      <div className="pl-10">
        {item?.children ? (
          // Render ParentIcon if item has children
          <ParentIcon
            showChildren={showChildren}
            toggleShowHide={toggleShowHide}
          />
        ) : (
          <CircleIcon />
        )}
      </div>
      <HeaderWrapper
        showHeader={showHeader}
        highlightData={highlightData}
        item={item}
        toggleShowHide={toggleShowHide}
      />
      <div className="goi-tooltip ml-10">
        <InfoIcon />
        <span className="goi-tooltiptext">{item.attrDescription}</span>
      </div>
      {editMode ? <EditIcon /> : <SavedIcon className="h-6 w-6" />}

      <b className="ml-10 tree-nav-item">{item.class}</b>
      {!!toggleShowHeader && (
        <b onClick={toggleShowHeader} className="ml-10 nav-btn tree-nav-item">
          {showHeader ? "Hide " : "Show "}Header
        </b>
      )}
      {id !== item.id && (
        <p
          id={item.id}
          onClick={setActiveObjectId}
          className="ml-10 nav-btn tree-nav-item"
        >
          Open as active object
        </p>
      )}
    </div>
  );
};

export default NodeHeader;
